<template>
  <div class="panel-in-tab">
    <search-box class="search-box">
      <el-form :inline="true" size="mini" label-width="100px" :model="searchForm" :rules="rules" ref="searchForm">
        <el-form-item label="直播批次" prop="liveBatchName">
          <el-select v-model="searchForm.liveBatchName" filterable multiple collapse-tags clearable @change="categoryDetailChange">
            <el-option v-show="!all2" label="全部" value=""></el-option>
            <el-option v-show="all2" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in liveBatchNameList" :label="item" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺" prop="storeName">
          <el-select v-model="searchForm.storeName" filterable multiple collapse-tags clearable @change="storeChange">
            <el-option v-show="!all" label="全部" value=""></el-option>
            <el-option v-show="all" label="取消所有" value="cancleAll"></el-option>
            <el-option v-for="item in storeNameList" :label="item" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="包件编码" prop="packCode">
          <el-input v-model="searchForm.packCode" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
        <el-form-item label="包件名称" prop="packName">
          <el-input v-model.trim="searchForm.packName" @keyup.enter.native="onSearch"></el-input>
        </el-form-item>
      </el-form>
      <template v-slot:right>
        <el-button class="green-btn" size="mini" @click="onSearch">搜索</el-button>
        <el-button class="orange-btn" size="mini" @click="reset">重置</el-button>
      </template>
    </search-box>

    <table-panel ref="tablePanel">
      <template v-slot:header-right>
        <div style="text-align: right">
          <el-button type="primary" size="mini" @click="exportExcel">导出</el-button>
        </div>
        <div style="padding-top: 10px; text-align: right" v-if="isShowText">预估量{{textNum.planAmount}}，实销量{{textNum.actualSaleNum}}</div>
      </template>
      <el-table
        stripe
        border
        ref="tableRef"
        :header-cell-style="{ backgroundColor: '#F4F8FB' }"
        highlight-current-row
        :data="tableData.list"
        :height="maxTableHeight"
        @sort-change="handleSortChange"
        v-if="tableReload"
        v-loading="loading"
      >
        <el-table-column
          v-for="(item, index) in columnData"
          :key="item.columnName + index"
          :align="`${item.fieldType == 'string' ? 'left' : 'right'}`"
          show-overflow-tooltip
          :label="item.displayName"
          :fixed="item.freezeType"
          :prop="item.columnName"
          :min-width="item.displayWidth"
        >
          <template slot-scope="scope">
            <template v-if="item.displayName == '图片'">
              <el-button type="text" @click="imgShow(scope.row)" v-if="scope.row.photoUrls">查看</el-button>
            </template>
            <template v-else>
              {{ scope.row[item.columnName] | cellValFormat }}
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template v-slot:footer>
        <div style="text-align: right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.pageNum"
            :page-sizes="[30, 100, 500, 1000]"
            :page-size="tableData.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            background
            :total="tableData.total"
          ></el-pagination>
        </div>
      </template>
    </table-panel>
    <el-dialog title="查看图片" :visible.sync="dialogFormVisible" :close-on-click-modal="false" width="50%" v-esc-close><imgShow :imgList="imgList"></imgShow></el-dialog>
  </div>
</template>

<script>
import imgShow from "@/views/components/imgShow.vue";
import tableMixin from "@/utils/tableMixin";
import axios from "@/utils/axiosInstance";
import moment from "moment";
export default {
  name: "jobDataAnalysis",
  mixins: [tableMixin],
  components: { imgShow },
  data() {
    return {
      loading: false,
      tableData: {
        list: [],
        pageNum: 1,
        pageSize: 30,
        total: 0,
      },
      tableReload: true,
      searchFormData: [],
      rules: {},
      reportName: "planLiveOrderPackInfo",
      columnData: [],
      storeList: [],
      categoryDetailList: [],
      loading: false,
      searchForm: {
        liveBatchName: "",
        storeName: "",
        packCode: "",
        packName: "",
      },
      exportData: {},
      orderSort: {},
      searchCollapse: false,
      all: false,
      all2: false,
      defaultStroe: [],
      currencyForm: {
        pageSize: 999999,
        pageNum: 1,
        reportCode: "",
        param: {},
        queryMatch: [
          // {
          //   attributeName: '',
          //   val: {},
          //   op: ''
          // }
        ],
        orderList: [
          // {
          //   attributeName: '',
          //   type: ''
          // }
        ],
        orderType: "",
        hasCount: "N",
        groupAttr: "",
      },
      imgList: [],
      storeNameList: [],
      liveBatchNameList: [],
      dialogFormVisible: false,
      textNum: {
        actualSaleNum: 0,
        planAmount: 0,
      }
    };
  },
  computed: {
    isShowText() {
      let searchForm = this.searchFormType || {};
      return (searchForm.packCode && searchForm.packCode.length == 1) || searchForm.packName;
    },
  },
  watch: {
    isShowText(val, old) {
      if(val) {
        this.onSearchSum()
      }
      this.addListener();
      this.setMaxHeight();
      this.$bus.$on("table.updateHeight", (offset) => {
        this.setMaxHeight(offset || 0);
      });
    },
  },
  mounted() {
    this.columns();
    this.getLiveBatchName()
    this.getStoreName()
  },
  methods: {
    columns() {
      this.loading = true;
      this.$q.goods.columns({ params: { reportName: this.reportName } }).then((res) => {
        this.columnData = res.data.sysColumns;
        this.onSearch();
      });
    },
    onSearchSum() {
      let { packCode, packName } = this.searchForm
      let data = {...this.currencyForm}
      data.reportCode = "planLiveOrderPackInfoSum"
      data.param = {
        packCode: packCode,
        packName: packName
      }
      axios
        .post(`/ec-pc-api/custom/reports/data/planLiveOrderPackInfoSum`, data)
        .then((res) => {
          if (res.code == 200) {
            this.textNum = {
              actualSaleNum: res.data.list[0].actualSaleNum || 0,
              planAmount: res.data.list[0].planAmount || 0,
            }
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSearch() {
      this.$refs.tableRef.clearSelection();
      this.tableData.pageNum = 1;
      this.queryCriteria = [
        {
          attributeName: "liveBatchName", //直播批次
          val: this.searchForm.liveBatchName ? this.searchForm.liveBatchName : [],
          op: "in",
        },
        {
          attributeName: "storeName", //店铺
          val: this.searchForm.storeName ? this.searchForm.storeName : [],
          op: "in",
        },
        {
          attributeName: "packCode", //包件编码
          val: this.searchForm.packCode ? this.searchForm.packCode.split(" ") : [],
          op: "in",
        },
        {
          attributeName: "packName", //包件名称
          val: this.searchForm.packName ? this.searchForm.packName : "",
          op: "like",
        },
      ];
      this.init();
    },
    async init(type) {
      this.loading = true;
      let filter = this.queryCriteria.filter((item) => item.val.length && item.val[0]);
      let data = {
        pageSize: this.tableData.pageSize,
        pageNum: this.tableData.pageNum,
        reportCode: this.reportName,
        param: {},
        queryMatch: filter || [],
        orderList: [],
        orderByColumn: "",
        orderType: "",
        hasCount: "Y",
      };
      if (type) {
        data.queryMatch = type.queryMatch;
        data.orderList = type.orderList;
      }
      this.searchFormData = data;
      this.searchFormType = {
        productCode: filter.filter((v) => v.attributeName == "productCode") || [],
        productName: this.searchForm.productName,
      };
      axios
        .post(`/ec-pc-api/custom/reports/data/${this.reportName}`, data)
        .then((res) => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 分页器 pagesize
    handleSizeChange(val) {
      this.tableData.pageSize = val;
      this.tableData.pageNum = 1;
      this.init(this.searchFormData);
    },
    // 分页器 pageNum
    handleCurrentChange(val) {
      this.tableData.pageNum = val;
      this.init(this.searchFormData);
    },

    reset() {
      this.$refs.searchForm.resetFields();
      this.all = false;
      this.all2 = false;
      this.tableData.pageNum = 1;
      this.onSearch();
    },
    storeChange(val) {
      this.all = this.storeNameList.length == val.length;
      if (val.includes("")) {
        this.searchForm.storeName = this.storeNameList;
        this.all = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.storeName = [];
        this.all = false;
      }
    },
    categoryDetailChange(val) {
      this.all2 = this.liveBatchNameList.length == val.length;
      if (val.includes("")) {
        this.searchForm.liveBatchName = this.liveBatchNameList;
        this.all2 = true;
      } else if (val.includes("cancleAll")) {
        this.searchForm.liveBatchName = [];
        this.all2 = false;
      }
    },

    //直播批次
    getLiveBatchName() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "liveBatchName";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.liveBatchNameList = data;
      });
    },
    //店铺
    getStoreName() {
      let data = { ...this.currencyForm };
      data.reportCode = this.reportName;
      data.groupAttr = "storeName";
      return this.$q.common.reportsDataGroup({ data: data }).then((res) => {
        let data = Object.keys(res.data.data).map((v) => {
          return v;
        });
        this.storeNameList = data;
      });
    },
    imgShow(row) {
      this.imgList = row.photoUrls.includes("|") ? row.photoUrls.spilt("|") : [row.photoUrls];
      this.dialogFormVisible = true;
    },

    handleSortChange({ column, prop, order }) {
      this.tableData.pageNum = 1;
      this.orderSort = {
        sortField: prop,
        sortOptions: order === "ascending" ? "0" : order === "descending" ? "1" : "",
      };
      this.init();
    },
    // 导出
    exportExcel() {
      console.log(this.searchFormData);
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      let params = {
        taskDTO: {
          appCode: "ec-pc-new",
          paramMap: {
            ...this.searchFormData,
          },
          reportName: this.reportName,
        },
        columnDTOs: [],
      };
      params.columnDTOs = this.columnData
        .map((item) => {
          return {
            columnName: item.displayName,
            fieldName: item.columnName,
            fieldType: "string",
            columnFormat: null,
          };
        })
        .filter((v) => v.columnName != "图片"); // 不导出图片列
      params.columnDTOs = params.columnDTOs.filter((v) => v.columnName !== "图片");
      this.$q.common.customExportExcel({ data: params }).then((res) => {
        if (res.success) {
          this.$message.success("提交下载任务成功，请稍后到导出列表查阅！");
          loading.close();
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
  filters: {
    cellValFormat(val) {
      if (val) {
        return val;
      } else {
        if (isNaN(val) || val == 0) {
          return val;
        } else {
          return "--";
        }
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
>>> .search-outer>div
  padding 0
>>> .el-select__tags-text {
display: inline-block;
max-width: 60px;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}
>>> .el-tag__close.el-icon-close {
  top: 0px;
  right: -4px
}
</style>
